export default __webpack_public_path__ + "static/media/bacqueville16.93ffc997.jpg";